@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import net.bothosting.docs.components.layouts.DocsLayout as _net_bothosting_docs_components_layouts_DocsLayout
import net.bothosting.docs.pages.HomePage as _net_bothosting_docs_pages_HomePage
import net.bothosting.docs.pages.READMEPage as _net_bothosting_docs_pages_READMEPage
import net.bothosting.docs.pages.SUMMARYPage as _net_bothosting_docs_pages_SUMMARYPage
import net.bothosting.docs.pages.community_resources.Bananaburner_panelPage as _net_bothosting_docs_pages_community_resources_Bananaburner_panelPage
import net.bothosting.docs.pages.community_resources.Node_and_website_uptime_monitorPage as _net_bothosting_docs_pages_community_resources_Node_and_website_uptime_monitorPage
import net.bothosting.docs.pages.community_resources.Useful_repositoriesPage as _net_bothosting_docs_pages_community_resources_Useful_repositoriesPage
import net.bothosting.docs.pages.create_a_discord_bot.How_toPage as _net_bothosting_docs_pages_create_a_discord_bot_How_toPage
import net.bothosting.docs.pages.faqs_and_info.Account_server_recoveryPage as _net_bothosting_docs_pages_faqs_and_info_Account_server_recoveryPage
import net.bothosting.docs.pages.faqs_and_info.Available_server_plansPage as _net_bothosting_docs_pages_faqs_and_info_Available_server_plansPage
import net.bothosting.docs.pages.faqs_and_info.Can_i_create_a_free_serverPage as _net_bothosting_docs_pages_faqs_and_info_Can_i_create_a_free_serverPage
import net.bothosting.docs.pages.faqs_and_info.Do_not_upload_node_modulesPage as _net_bothosting_docs_pages_faqs_and_info_Do_not_upload_node_modulesPage
import net.bothosting.docs.pages.faqs_and_info.How_to_write_a_support_requestPage as _net_bothosting_docs_pages_faqs_and_info_How_to_write_a_support_requestPage
import net.bothosting.docs.pages.faqs_and_info.Issues_creating_server_free_usersPage as _net_bothosting_docs_pages_faqs_and_info_Issues_creating_server_free_usersPage
import net.bothosting.docs.pages.faqs_and_info.My_server_is_suspendedPage as _net_bothosting_docs_pages_faqs_and_info_My_server_is_suspendedPage
import net.bothosting.docs.pages.faqs_and_info.Nodes_ip_and_informationPage as _net_bothosting_docs_pages_faqs_and_info_Nodes_ip_and_informationPage
import net.bothosting.docs.pages.faqs_and_info.Payment_guidePage as _net_bothosting_docs_pages_faqs_and_info_Payment_guidePage
import net.bothosting.docs.pages.faqs_and_info.Premium_support_and_nodesPage as _net_bothosting_docs_pages_faqs_and_info_Premium_support_and_nodesPage
import net.bothosting.docs.pages.faqs_and_info.Running_installerPage as _net_bothosting_docs_pages_faqs_and_info_Running_installerPage
import net.bothosting.docs.pages.faqs_and_info.Why_didnt_i_receive_coins_after_inviting_to_registerPage as _net_bothosting_docs_pages_faqs_and_info_Why_didnt_i_receive_coins_after_inviting_to_registerPage
import net.bothosting.docs.pages.hosting_in_bot_hosting_net.Clone_a_git_repository_on_your_serverPage as _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Clone_a_git_repository_on_your_serverPage
import net.bothosting.docs.pages.hosting_in_bot_hosting_net.Coin_system_explainedPage as _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Coin_system_explainedPage
import net.bothosting.docs.pages.hosting_in_bot_hosting_net.Connect_to_your_servers_files_with_sftpPage as _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Connect_to_your_servers_files_with_sftpPage
import net.bothosting.docs.pages.hosting_in_bot_hosting_net.Create_a_serverPage as _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Create_a_serverPage
import net.bothosting.docs.pages.hosting_in_bot_hosting_net.Create_an_accountPage as _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Create_an_accountPage
import net.bothosting.docs.pages.hosting_in_bot_hosting_net.Link_a_domain_to_your_serverPage as _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Link_a_domain_to_your_serverPage
import net.bothosting.docs.pages.hosting_in_bot_hosting_net.Manage_server_subusersPage as _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Manage_server_subusersPage
import net.bothosting.docs.pages.hosting_in_bot_hosting_net.Set_up_a_serverPage as _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Set_up_a_serverPage
import net.bothosting.docs.pages.troubleshooting.An_unexpected_error_was_encountered_while_handling_this_requestPage as _net_bothosting_docs_pages_troubleshooting_An_unexpected_error_was_encountered_while_handling_this_requestPage
import net.bothosting.docs.pages.troubleshooting.Another_power_action_is_currently_being_processed_for_this_serverPage as _net_bothosting_docs_pages_troubleshooting_Another_power_action_is_currently_being_processed_for_this_serverPage
import net.bothosting.docs.pages.troubleshooting.Better_sqlite_errorPage as _net_bothosting_docs_pages_troubleshooting_Better_sqlite_errorPage
import net.bothosting.docs.pages.troubleshooting.Cannot_find_module_modulenotfounderror_no_such_file_or_directoryPage as _net_bothosting_docs_pages_troubleshooting_Cannot_find_module_modulenotfounderror_no_such_file_or_directoryPage
import net.bothosting.docs.pages.troubleshooting.Invalid_elf_headerPage as _net_bothosting_docs_pages_troubleshooting_Invalid_elf_headerPage
import net.bothosting.docs.pages.troubleshooting.Invalid_token_has_been_provided_token_invalidPage as _net_bothosting_docs_pages_troubleshooting_Invalid_token_has_been_provided_token_invalidPage
import net.bothosting.docs.pages.troubleshooting.Request_failed_with_status_code_504Page as _net_bothosting_docs_pages_troubleshooting_Request_failed_with_status_code_504Page
import net.bothosting.docs.pages.troubleshooting.Server_rate_limitsPage as _net_bothosting_docs_pages_troubleshooting_Server_rate_limitsPage
import net.bothosting.docs.pages.troubleshooting.The_requested_resource_does_not_exist_on_this_serverPage as _net_bothosting_docs_pages_troubleshooting_The_requested_resource_does_not_exist_on_this_serverPage
import net.bothosting.docs.pages.troubleshooting.Unknown_interactionPage as _net_bothosting_docs_pages_troubleshooting_Unknown_interactionPage
import net.bothosting.docs.pages.troubleshooting.Upload_unarchive_errorsPage as _net_bothosting_docs_pages_troubleshooting_Upload_unarchive_errorsPage
import net.bothosting.docs.pages.troubleshooting.Were_having_some_trouble_connecting_to_your_serverPage as _net_bothosting_docs_pages_troubleshooting_Were_having_some_trouble_connecting_to_your_serverPage

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.api.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Bh Docs"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "net.bothosting.docs.components.layouts.DocsLayout",
        ) { pageCtx, pageMethod -> 
            _net_bothosting_docs_components_layouts_DocsLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
        ) { pageCtx -> 
            _net_bothosting_docs_pages_HomePage()
        }
        ctx.router.register(
            "/community_resources/bananaburner-panel",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.community_resources.initBananaburner_panelPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_community_resources_Bananaburner_panelPage()
        }
        ctx.router.register(
            "/community_resources/node-and-website-uptime-monitor",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.community_resources.initNode_and_website_uptime_monitorPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_community_resources_Node_and_website_uptime_monitorPage()
        }
        ctx.router.register(
            "/community_resources/useful-repositories",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.community_resources.initUseful_repositoriesPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_community_resources_Useful_repositoriesPage()
        }
        ctx.router.register(
            "/create_a_discord_bot/how-to",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.create_a_discord_bot.initHow_toPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_create_a_discord_bot_How_toPage()
        }
        ctx.router.register(
            "/faqs_and_info/account-server-recovery",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initAccount_server_recoveryPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_Account_server_recoveryPage()
        }
        ctx.router.register(
            "/faqs_and_info/available-server-plans",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initAvailable_server_plansPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_Available_server_plansPage()
        }
        ctx.router.register(
            "/faqs_and_info/can-i-create-a-free-server",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initCan_i_create_a_free_serverPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_Can_i_create_a_free_serverPage()
        }
        ctx.router.register(
            "/faqs_and_info/do-not-upload-node-modules",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initDo_not_upload_node_modulesPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_Do_not_upload_node_modulesPage()
        }
        ctx.router.register(
            "/faqs_and_info/how-to-write-a-support-request",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initHow_to_write_a_support_requestPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_How_to_write_a_support_requestPage()
        }
        ctx.router.register(
            "/faqs_and_info/issues-creating-server-free-users",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initIssues_creating_server_free_usersPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_Issues_creating_server_free_usersPage()
        }
        ctx.router.register(
            "/faqs_and_info/my-server-is-suspended",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initMy_server_is_suspendedPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_My_server_is_suspendedPage()
        }
        ctx.router.register(
            "/faqs_and_info/nodes-ip-and-information",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initNodes_ip_and_informationPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_Nodes_ip_and_informationPage()
        }
        ctx.router.register(
            "/faqs_and_info/payment-guide",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initPayment_guidePage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_Payment_guidePage()
        }
        ctx.router.register(
            "/faqs_and_info/premium-support-and-nodes",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initPremium_support_and_nodesPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_Premium_support_and_nodesPage()
        }
        ctx.router.register(
            "/faqs_and_info/running-installer",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initRunning_installerPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_Running_installerPage()
        }
        ctx.router.register(
            "/faqs_and_info/why-didnt-i-receive-coins-after-inviting-to-register",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.faqs_and_info.initWhy_didnt_i_receive_coins_after_inviting_to_registerPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_faqs_and_info_Why_didnt_i_receive_coins_after_inviting_to_registerPage()
        }
        ctx.router.register(
            "/hosting_in_bot_hosting_net/clone-a-git-repository-on-your-server",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.hosting_in_bot_hosting_net.initClone_a_git_repository_on_your_serverPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Clone_a_git_repository_on_your_serverPage()
        }
        ctx.router.register(
            "/hosting_in_bot_hosting_net/coin-system-explained",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.hosting_in_bot_hosting_net.initCoin_system_explainedPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Coin_system_explainedPage()
        }
        ctx.router.register(
            "/hosting_in_bot_hosting_net/connect-to-your-servers-files-with-sftp",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.hosting_in_bot_hosting_net.initConnect_to_your_servers_files_with_sftpPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Connect_to_your_servers_files_with_sftpPage()
        }
        ctx.router.register(
            "/hosting_in_bot_hosting_net/create-a-server",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.hosting_in_bot_hosting_net.initCreate_a_serverPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Create_a_serverPage()
        }
        ctx.router.register(
            "/hosting_in_bot_hosting_net/create-an-account",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.hosting_in_bot_hosting_net.initCreate_an_accountPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Create_an_accountPage()
        }
        ctx.router.register(
            "/hosting_in_bot_hosting_net/link-a-domain-to-your-server",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.hosting_in_bot_hosting_net.initLink_a_domain_to_your_serverPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Link_a_domain_to_your_serverPage()
        }
        ctx.router.register(
            "/hosting_in_bot_hosting_net/manage-server-subusers",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.hosting_in_bot_hosting_net.initManage_server_subusersPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Manage_server_subusersPage()
        }
        ctx.router.register(
            "/hosting_in_bot_hosting_net/set-up-a-server",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.hosting_in_bot_hosting_net.initSet_up_a_serverPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_hosting_in_bot_hosting_net_Set_up_a_serverPage()
        }
        ctx.router.register(
            "/readme",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.initREADMEPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_READMEPage()
        }
        ctx.router.register(
            "/summary",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.initSUMMARYPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_SUMMARYPage()
        }
        ctx.router.register(
            "/troubleshooting/an-unexpected-error-was-encountered-while-handling-this-request",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initAn_unexpected_error_was_encountered_while_handling_this_requestPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_An_unexpected_error_was_encountered_while_handling_this_requestPage()
        }
        ctx.router.register(
            "/troubleshooting/another-power-action-is-currently-being-processed-for-this-server",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initAnother_power_action_is_currently_being_processed_for_this_serverPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_Another_power_action_is_currently_being_processed_for_this_serverPage()
        }
        ctx.router.register(
            "/troubleshooting/better-sqlite-error",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initBetter_sqlite_errorPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_Better_sqlite_errorPage()
        }
        ctx.router.register(
            "/troubleshooting/cannot-find-module-modulenotfounderror-no-such-file-or-directory",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initCannot_find_module_modulenotfounderror_no_such_file_or_directoryPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_Cannot_find_module_modulenotfounderror_no_such_file_or_directoryPage()
        }
        ctx.router.register(
            "/troubleshooting/invalid-elf-header",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initInvalid_elf_headerPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_Invalid_elf_headerPage()
        }
        ctx.router.register(
            "/troubleshooting/invalid-token-has-been-provided-token-invalid",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initInvalid_token_has_been_provided_token_invalidPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_Invalid_token_has_been_provided_token_invalidPage()
        }
        ctx.router.register(
            "/troubleshooting/request-failed-with-status-code-504",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initRequest_failed_with_status_code_504Page(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_Request_failed_with_status_code_504Page()
        }
        ctx.router.register(
            "/troubleshooting/server-rate-limits",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initServer_rate_limitsPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_Server_rate_limitsPage()
        }
        ctx.router.register(
            "/troubleshooting/the-requested-resource-does-not-exist-on-this-server",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initThe_requested_resource_does_not_exist_on_this_serverPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_The_requested_resource_does_not_exist_on_this_serverPage()
        }
        ctx.router.register(
            "/troubleshooting/unknown-interaction",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initUnknown_interactionPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_Unknown_interactionPage()
        }
        ctx.router.register(
            "/troubleshooting/upload-unarchive-errors",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initUpload_unarchive_errorsPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_Upload_unarchive_errorsPage()
        }
        ctx.router.register(
            "/troubleshooting/were-having-some-trouble-connecting-to-your-server",
            layoutId = "net.bothosting.docs.components.layouts.DocsLayout",
            initRouteMethod = { ctx ->
                net.bothosting.docs.pages.troubleshooting.initWere_having_some_trouble_connecting_to_your_serverPage(ctx)
            },
        ) { pageCtx -> 
            _net_bothosting_docs_pages_troubleshooting_Were_having_some_trouble_connecting_to_your_serverPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", net.bothosting.docs.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", net.bothosting.docs.SubheadlineTextStyle)
        ctx.theme.registerVariant("-circle", net.bothosting.docs.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", net.bothosting.docs.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("pulse", net.bothosting.docs.components.ui.Pulse)
        net.bothosting.docs.initColorMode(ctx)
        net.bothosting.docs.initStyles(ctx)
        net.bothosting.docs.initSiteStyles(ctx)
        net.bothosting.docs.initTheme(ctx)
        net.bothosting.docs.initSilk(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        net.bothosting.docs.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
